import SelectInput from '../components/selectInput';
import handleError from '../handleError';
import evalStepFooter from './../components/eval-step-footer';
import evalTooltip from '../components/eval-tooltip';
import { getFormRelationList } from '../service.js';

export default {
  components: {
    SelectInput,
    yxtbizEvalStepFooter: evalStepFooter,
    evalTooltip
  },
  mixins: [handleError],
  props: {
    stepsData: {
      type: Array
    },
    sourceType: {
      type: Number
    },
    id: {
      type: String,
      default: ''
    },
    // 绑定岗位地图、层级地图等方法
    bindMap: {
      type: Function,
      default: () => {
      }
    }
  },

  data() {
    const defaultRelation = {
      1: {
        type: '1',
        prop: 'enabledSelf',
        label: this.$t('pc_gwnl_chart_type_selfLevel'),
        checkboxLabel: this.$t('pc_gwnl_eval_selfEval'),
        weight: 'weightSelf'
      },
      2: {
        type: '2',
        prop: 'enabledLeader',
        label: this.$t('pc_gwnl_chart_type_leaderLevel'),
        checkboxLabel: this.$t('pc_gwnl_global_leaderAssessment'),
        weight: 'weightLeader'
      },
      3: {
        type: '3',
        prop: 'enabledEqual',
        label: this.$t('pc_gwnl_chart_type_equalLevel'),
        checkboxLabel: this.$t('pc_gwnl_global_equalAssessment'),
        weight: 'weightEqual'
      },
      4: {
        type: '4',
        prop: 'enabledSubordinate',
        label: this.$t('pc_gwnl_chart_type_subordinateLevel'),
        checkboxLabel: this.$t('pc_gwnl_global_subordinateAssessment'),
        weight: 'weightSubordinate'
      }
    };
    return {
      defaultRelation,
      isSubmitting: false,
      loading: false,
      leaderType: '',
      weight: {
        weightSelf: 0,
        weightLeader: 0,
        weightEqual: 0,
        weightSubordinate: 0
      },
      evalRelation: [],
      expend: false,
      targetType: 1 // 当前创建出来的测评的类型
    };
  },

  computed: {
    // 计算权重列表
    weightList() {
      return this.isEnabledList();
    }
  },

  watch: {
    type(value) {
      this.form.type = value;
    }
  },

  methods: {
    validateWeight(rule, value, callback) {
      if (this.form.evaluationConfig4Create.weightType === 1) {
        callback();
      }

      let total = 0;
      const zeroWeightList = [];
      (this.weightList || []).forEach(item => {
        total = total + this.weight[item.weight];
        if (this.weight[item.weight] === 0) {
          zeroWeightList.push(item.label);
        }
      });

      if (zeroWeightList && zeroWeightList.length) {
        callback(new Error(this.$t('pc_gwnl_eval_msg_pleaseSetWeight')));
      }

      if (this.form.evaluationConfig4Create.weightType === 2 && total !== 100) {
        callback(new Error(this.$t('pc_gwnl_eval_msg_pleaseAdjustWeights')));
      }
      callback();
    },

    save() {
      if (this.isSubmitting) return;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.postEvalInfo(null, 1);
        }
      });
    },

    // 下一步
    next() {
      if (this.isSubmitting) return;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.postEvalInfo(() => {
            this.$emit('next');
          }, 3);
        } else {
          // 请检查必填项
          this.$message.error(this.$t('pc_biz_enroll_msg_inputrequire'));
        }
      });
    },

    // 处理平均权重
    setAverageWeight() {
      if (!(this.weightList && this.weightList.length)) return;

      if (this.form.evaluationConfig4Create.weightType === 1) {
        this.$refs.form.validateField('form.weight');
      }

      this.weight = {};
      this.weight.weightSelf = 0;
      this.weight.weightLeader = 0;
      this.weight.weightEqual = 0;
      this.weight.weightSubordinate = 0;
      const weightCount = this.weightList.length;

      // 默认只有长度为1时，重置权重type
      if (weightCount === 1) {
        this.form.evaluationConfig4Create.weightType = 1;
      }

      this.weightList.forEach((item, index) => {
        const val = parseInt(100 / weightCount, 10);
        const isLast = this.form.evaluationConfig4Create.weightType === 2 && weightCount - 1 === index;
        const weight = isLast ? 100 - val * (weightCount - 1) : val;
        this.$set(this.weight, item.weight, weight);
      });
    },

    // 上一步
    prev() {
      this.$emit('prev');
    },

    // 设置默认的自定义配置
    setCustomEvalConfig(evaluationConfig) {
      if (evaluationConfig.customEvalConfigs && evaluationConfig.customEvalConfigs.length) {
        evaluationConfig.customEvalConfigs.forEach(dimension => {
          if (dimension.relationType) {
            let key = 'enabledCustom' + dimension.relationType;
            let key2 = 'weightCustom' + dimension.relationType;
            const itemWeight = (dimension.weight && dimension.weight) || 0;

            // 根据自定义关系返回，设置默认值
            this.$set(evaluationConfig, key, Number(Boolean(itemWeight)));
            this.$set(evaluationConfig, key2, itemWeight);
          }
        });
      }
    },

    updateEvaluationConfig(config) {
      // 设置对应关系时先置空
      this.weight = {};
      this.$set(this.form, 'weight', {});

      // 处理默认选中上级评估人员
      this.leaderType = config.enabledLeaderDm
        ? 'enabledLeaderDm'
        : 'enabledLeaderPm';
      for (const key in config) {
        if (key.includes('weight') && config[key] && key !== 'weightType') {
          this.weight[key] = config[key];
        }
      }

      this.form.weight = this.weight;
    },

    resetData() {
      // 如果测评工具没有发生变化，则不清空数据
      if (!this.surveyChanged || this.bfId) return;
      // 先赋值给变量oldSurveyId防止后面被统一初始化成原始值
      const oldSurveyId = this.oldSurveyId;

      this.loading = true;
      const orgionData = this.$options.data.call(this);
      for (const key in orgionData) {
        this[key] = orgionData[key];
      }
      this.oldSurveyId = oldSurveyId;
    },

    // 如果不是行为评估，isSelctedAll为true表示所有都会被选中
    checkedAllDimension(isSelctedAll) {
      if (!this.dimensionInfo) return;

      let oldDimensionTypes = [];
      if (this.bfId) {
        // 如果选择的工具仅有自评，则直接按照自评处理，否则取前测的评估关系比对
        // 因为行为不调用getCurSurvey，所以这里统一用oldSurveyUtil
        // 这边导入的测评selfAssess|peerAssess为null
        if (this.selfAssess === 1 && this.peerAssess === 0 && !this.isBehavior) {
          oldDimensionTypes = ['1'];
        } else {
          const beforeDimensionInfo = this.oldSurveyUtil.dimensionInfoBeans || [];
          oldDimensionTypes = beforeDimensionInfo.map(item => item.type);
        }

        // 行为-行为｜行为-工具-行为，使用setEvalData的评估关系和权重即可
        // 行为评估-无oldSurveyId
        // 使用缓存的评估关系和权重
        if (this.bfId && this.isBehavior && !this.oldSurveyId) {
          const dimensionInfoTypes = this.dimensionInfo.map(item => item.type);
          const isAllType = oldDimensionTypes.every(type => dimensionInfoTypes.includes(type));

          // 为了防止行为评估下的评估关系被删除，所以要比较下是否当下前测的评估关系都在评估列表里
          // 相同直接使用，不同则重新计算评估权重
          if (isAllType) {
            this.setFormEva({ evaluationConfig: this.oldEvaluationConfig });
          } else {
            this.$nextTick(this.setAverageWeight);
          }
          return;
        };

        // 重置默认评估关系的值
        this.defaultTypes.forEach(type => {
          this.form.evaluationConfig4Create[type] = 0;
        });
      }

      // 需要等待 dimensionInfo 正确更新后再勾选所有评估关系，再重算平均值
      this.$nextTick(() => {
        this.dimensionInfo.forEach(({ type }, index) => {
          // 如果是前测，则只勾选和之前工具相同的评估关系
          // 否则按照isSelctedAll来确认是否勾选全部，或者勾选前4个
          const beforeSelected = this.bfId && oldDimensionTypes.includes(type) ? 1 : 0;
          const isSelected = isSelctedAll ? (isSelctedAll ? 1 : 0) : (index < 4 ? 1 : 0);
          const relationSelected = this.bfId ? beforeSelected : isSelected;

          if (this.defaultRelation[type]) {
            this.form.evaluationConfig4Create[this.defaultRelation[type].prop] = relationSelected;
          } else {
            // 处理自定义评估默认选中
            this.$set(this.form.evaluationConfig4Create, 'enabledCustom' + type, relationSelected);
          }
        });

        // 重置上级评估对应的关系
        // 如果是前后测绑定则不需要重置，按照前测配置的来
        if (this.form.evaluationConfig4Create.enabledLeader && !this.bfId) {
          this.form.evaluationConfig4Create.enabledLeaderPm = 1;
          this.leaderType = 'enabledLeaderPm';
        }

        if (this.surveyId === this.oldSurveyId && this.bfId) {
          this.setFormEva({ evaluationConfig: this.oldEvaluationConfig });
        } else {
          // 更新 evaluationConfig4Create 后需要等待enabledCount计算完成后才能执行setAverageWeight
          this.$nextTick(this.setAverageWeight);
        }
      });
    },

    // 改变是否开启上级评估值
    changeLeaderEnable(val) {
      if (val === 0) {
        this.form.evaluationConfig4Create.enabledLeaderDm = 0;
        this.form.evaluationConfig4Create.enabledLeaderPm = 0;
        this.leaderType = '';
      } else {
        this.form.evaluationConfig4Create.enabledLeaderPm = 1;
        this.leaderType = 'enabledLeaderPm';
      }
      this.setAverageWeight();
    },

    // 改变上级评估评估人
    changeLeaderType(val) {
      this.form.evaluationConfig4Create.enabledLeaderDm =
        val === 'enabledLeaderDm' ? 1 : 0;
      this.form.evaluationConfig4Create.enabledLeaderPm =
        val === 'enabledLeaderPm' ? 1 : 0;
    },
    changeEnable(val, type) {
      // 开关关闭，权重值置为0
      this.setAverageWeight();
      if (!val) {
        switch (type) {
          case '1':
            this.weight.weightSelf = 0;
            break;
          case '3':
            this.weight.weightEqual = 0;
            break;
          case '4':
            this.weight.weightSubordinate = 0;
            break;
          default:
            break;
        }
      }
    },

    handleFormatter(value) {
      return value === undefined ? undefined : `${value}%`;
    },

    setRelations(array) {
      this.evalRelation = array.map(dimension => {
        if (!dimension.isDefault) {
          return {
            ...this.defaultRelation[dimension.type]
          };
        } else {
          return {
            label: dimension.dimensionName,
            type: dimension.type,
            value: 'enabledCustom' + dimension.type,
            prop: 'enabledCustom' + dimension.type,
            weight: 'weightCustom' + dimension.type,
            weightsLabel: dimension.dimensionName,
            isDefault: 1
          };
        }
      }).sort((a, b) => a.sort - b.sort) || [];
    },

    // 根据checkedAllDimension方法中获取自定义评估和默认评估打开的list数据
    isEnabledList() {
      if (!this.evalRelation.length) return;
      return this.evalRelation.filter(item => {
        return this.form.evaluationConfig4Create[item.prop];
      });
    },

    // 禁用对应选择的checkbox
    disabledRelationBox(item) {
      if (this.weightList && this.weightList.length >= 6) {
        const formEnable = this.weightList.find(list => list.type === item.type);

        if (formEnable) {
          return !this.form.evaluationConfig4Create[formEnable.prop];
        }

        return true;
      }
      return false;
    },

    async getRelationCustomList(id) {
      try {
        const result = await getFormRelationList(id);
        if (!result.length) return [];
        return result.map(item => {
          return {
            ...item,
            type: item.dimensionType,
            isDefault: item.custom,
            label: item.custom ? item.dimensionName : this.defaultRelation[item.dimensionType].checkboxLabel,
            prop: item.custom ? `enabledCustom${item.dimensionType}` : this.defaultRelation[item.dimensionType].prop
          };
        });
      } catch (error) {
        console.log(error);
      }
    },

    async getListAndSetRelation(id = '', thisAttr) {
      try {
        this[thisAttr] = await this.getRelationCustomList(id);
        if (this[thisAttr] && this[thisAttr].length) {
          this.setRelations(this[thisAttr]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
